import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';
import { PlanningScenarioFindInterface } from '@zaoblako/shared/modules/finance/dtos/planning-scenario/planning-scenario-find.dto';
import { PlanningScenarioService } from '@zaoblako/web/core/services/budget/planning-scenario.service';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';
import { BaseSingleSelectComponent } from '@zaoblako/web/shared/components/base-single-select/base-single-select.component';
import { Observable } from 'rxjs';
import { DropdownBaseQueryInterface } from '@zaoblako/shared/common/dtos/dropdown-base-query.dto';
import { PaginationFindInterface } from '@zaoblako/shared/common/dtos/pagination-find.dto';

@Component({
  selector: 'crm-planning-scenario-single-select',
  standalone: true,
  imports: [CommonModule, SingleSelectComponent, SpinnerComponent],
  templateUrl: './planning-scenario-single-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanningScenarioSingleSelectComponent extends BaseSingleSelectComponent<PlanningScenarioFindInterface> {
  public availableModule = 'FINANCE';
  protected override readonly entityCacheKind = 'planning-scenario';

  @Input() public selectLabel = 'Сценарий планирования';
  @Input() public virtualScroll = false;
  @Input() public virtualScrollItemSize = 33;
  @Input() public scrollHeight = '300px';

  public constructor(private readonly planningScenarioService: PlanningScenarioService) {
    super();
  }

  public findById(id: number): Observable<PlanningScenarioFindInterface> {
    return this.planningScenarioService.findById(id);
  }

  public findWithPagination(
    queryParams: Partial<DropdownBaseQueryInterface>
  ): Observable<PaginationFindInterface<PlanningScenarioFindInterface>> {
    return this.planningScenarioService.findWithPagination(queryParams);
  }
}
